import stripUndefined from "lib/utils/stripUndefined";
import { get } from "lodash";
import type { ParsedUrlQuery } from "querystring";

// UTM parameters. See: https://en.wikipedia.org/wiki/UTM_parameters
const UTM_SOURCE = "utm_source";
const UTM_MEDIUM = "utm_medium";
const UTM_CAMPAIGN = "utm_campaign";
const UTM_TERM = "utm_term";
const UTM_CONTENT = "utm_content";

export function getUtmParametersFromUrl(rawUrl: string) {
  const url = new URL(rawUrl);

  return stripUndefined({
    utmSource: url.searchParams.get(UTM_SOURCE),
    utmMedium: url.searchParams.get(UTM_MEDIUM),
    utmCampaign: url.searchParams.get(UTM_CAMPAIGN),
    utmTerm: url.searchParams.get(UTM_TERM),
    utmContent: url.searchParams.get(UTM_CONTENT),
  });
}

export function getUtmParametersFromParsedUrlQuery(query: ParsedUrlQuery) {
  return stripUndefined({
    utmSource: firstOrNull(get(query, UTM_SOURCE)),
    utmMedium: firstOrNull(get(query, UTM_MEDIUM)),
    utmCampaign: firstOrNull(get(query, UTM_CAMPAIGN)),
    utmTerm: firstOrNull(get(query, UTM_TERM)),
    utmContent: firstOrNull(get(query, UTM_CONTENT)),
  });
}

function firstOrNull(input: string | string[] | null | undefined): string | null {
  if (!input) {
    return null;
  }
  if (Array.isArray(input)) {
    return input[0] || null;
  }
  return input;
}
